var _path, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnEditLight = function SvgIcnEditLight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.37626 18.5015L4.38644 15.3378L11.7487 8.0228L14.9423 11.1568L7.53993 18.5117L4.37626 18.5015ZM16.0065 10.0994L17.8458 8.27188C17.9928 8.1259 17.9935 7.88847 17.8476 7.74155L15.2227 5.09973C15.0767 4.95282 14.8393 4.95206 14.6924 5.09803L12.8129 6.96547L16.0065 10.0994ZM8.34007 19.8312C8.22248 19.948 8.0633 20.0134 7.89754 20.0128L3.49644 19.9987C3.15127 19.9976 2.87234 19.7168 2.87346 19.3717L2.88762 14.9706C2.88815 14.8048 2.95451 14.6461 3.0721 14.5292L13.6351 4.03396C14.3697 3.30409 15.5569 3.30791 16.2867 4.04249L18.9116 6.68431C19.6415 7.4189 19.6377 8.60607 18.9031 9.33595L8.34007 19.8312Z",
    fill: "currentcolor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 11.5388,
    y1: 19.29,
    x2: 21.25,
    y2: 19.29,
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnEditLight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_edit_light.0b19f270.svg";
export { ForwardRef as ReactComponent };